<script setup>
    import { ref } from 'vue'

    const props = defineProps({
        sections: Object
    })

    let show = ref(null)

    function onBeforeEnter(el) {
        el.style.height = '0'
        el.style.opacity = '0'
    }
    function onEnter (el) {
        el.style.height = el.scrollHeight + 'px'
        el.style.opacity = '1'
    }
    function onBeforeLeave(el) {
        el.style.height = el.scrollHeight + 'px'
        el.style.opacity = '1'
    }
    function onLeave(el) {
        el.style.height = '0'
        el.style.opacity = '0'
    }

    function toggle(index) {
        if ( index === show.value ) {
            show.value = null
        } else {
            show.value = index
        }
    }
</script>
<template>
    <ul>
        <li v-for="( item, index ) in sections"
            :key="index"
            class="accordion py-6 border-b border-cintra-grey border-solid">

            <div
                class="w-full relative py-2 flex justify-between items-center gap-6 cursor-pointer group"
                @click="toggle(index)"
            >
                <span class="font-heading font-bold text-xl text-cintra-grey group-hover:text-cintra-orange transition duration-300">
                    {{ item.heading_question }}
                </span>
                <i class="fa-thin fa-circle-arrow-down text-3xl text-cintra-grey transition duration-300 group-hover:text-cintra-orange" :class="{ 'flip-x': show === index }"></i>
            </div>

            <transition name="accordion"
                @before-enter="onBeforeEnter"
                @enter="onEnter"
                @before-leave="onBeforeLeave"
                @leave="onLeave">
                <div
                    class="body rich-text-body overflow-hidden"
                    v-show="show === index"
                    v-html="item.text_answer"
                />
            </transition>
        </li>
    </ul>
</template>
<style lang="scss">
    .accordion .body {
        @apply transition motion-reduce:transition-none duration-300 ease-in-out;
    }
</style>
